export default "__VITE_ASSET__p18eJoWy__"